import { ChevronRight } from 'lucide-react';
import { NAV_TREE, visibleLimbs } from '@/lib/navTree';

const THEME = {
  primary: 'bg-primary/10 text-primary',
  green: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  slate: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
};

const Tile = ({ icon: Icon, label, hint, theme, onClick, soon, testid }) => (
  <button type="button" onClick={onClick} disabled={soon} data-testid={testid}
    className={`group w-full text-left flex items-center gap-3 p-4 rounded-xl border bg-card transition-[border-color,box-shadow,transform] ${soon ? 'opacity-60 cursor-not-allowed' : 'hover:border-primary/40 hover:shadow-sm active:scale-[0.99]'}`}>
    <div className={`h-11 w-11 rounded-lg flex items-center justify-center shrink-0 ${theme}`}><Icon className="h-5 w-5" /></div>
    <div className="flex-1 min-w-0">
      <p className="font-semibold text-sm">{label}</p>
      {hint && <p className="text-xs text-muted-foreground mt-0.5">{hint}</p>}
    </div>
    {soon ? <span className="text-[10px] px-2 py-0.5 rounded-full bg-muted text-muted-foreground shrink-0">Coming soon</span>
      : <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 group-hover:translate-x-0.5 transition-transform" />}
  </button>
);

// Main page of a module, built from the same list as the sidebar and phone menus.
export default function ModuleLanding({ trunkId, onNavigate, ctx = {}, intro, comingSoon = [] }) {
  const trunk = NAV_TREE.find((t) => t.id === trunkId);
  const theme = THEME[trunk.color];
  const Icon = trunk.icon;
  return (
    <div className="space-y-5 p-4 sm:p-6" data-testid={`module-landing-${trunkId}`}>
      <div className="flex items-start gap-3">
        <div className={`p-2.5 rounded-lg shrink-0 ${theme}`}><Icon className="h-6 w-6" /></div>
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="module-landing-title">{trunk.label}</h1>
          <p className="text-sm text-muted-foreground mt-0.5">{trunk.subtitle}</p>
        </div>
      </div>
      {intro}
      <div className="grid gap-3 sm:grid-cols-2">
        {visibleLimbs(trunk, ctx).map((l) => (
          <Tile key={l.id} icon={l.icon} label={l.label} hint={l.hint} theme={theme} onClick={() => onNavigate(l.id)} testid={`module-tile-${l.id}`} />
        ))}
        {comingSoon.map((c) => <Tile key={c.id} {...c} theme={theme} soon testid={`module-tile-${c.id}`} />)}
      </div>
    </div>
  );
}
